import React, { createRef, useEffect } from "react";
import anime from "animejs/lib/anime.es.js";
import styled from 'styled-components';

import HeartsSrc from '@cover/kopfstandstarten/heart';
import LampSrc from '@cover/kopfstandstarten/lamp';

import handRightSrc from '@cover/kopfstandstarten/hand-right.svg';
import handLeftSrc from '@cover/kopfstandstarten/hand-left.svg';
import handTopSrc from '@cover/kopfstandstarten/hand-top.svg';
import eyesSrc from '@cover/kopfstandstarten/eyes.svg';
import smileySrc from '@cover/kopfstandstarten/smiley.svg';


const Hearts = styled(HeartsSrc)`
	position: absolute;
	height: 8%;
	right: 33.5%;
	bottom: 35.5%;
`
const Lamp = styled(LampSrc)`
	position: absolute;
	height: 9.8%;
	left: 34.3%;
	top: 7.8%;
`

const AnimatedLayer = styled.img`
	position: absolute;
`
const HandLeft = styled(AnimatedLayer)`
	height: 21%;
	left: -30%;
	top: 38%;
`
const HandRight = styled(AnimatedLayer)`
	height: 21%;
	right: -25%;
	top: 38%;
	z-index: 333;
`
const HandTop = styled(AnimatedLayer)`
	transform-origin: top center;
	z-index: 777;
`
const Eyes= styled(AnimatedLayer)`
	height: 9.9%;
	right: 14.8%;
	top: 8.8%;
	transform-origin: center center;
`
const Smiley = styled(AnimatedLayer)`
	height: 15%;
	left: 4%;
	bottom: 30%;
	transform-origin: center center;
`

const KopfstandStarten = ({ play }) => {
	const hearts = createRef();
	const lampItems = createRef();

	const handRight = createRef();
	const handLeft = createRef();
	const handTop = createRef();
	const smiley = createRef();
	const eyes = createRef();


	useEffect(() => {
		const heartTop = hearts.current.querySelector('#heart_svg__heart-top')
		const heartLeft = hearts.current.querySelector('#heart_svg__heart-left')
		const heartRight = hearts.current.querySelector('#heart_svg__heart-right')

		const lamp = lampItems.current.querySelector('#lamp_svg__lamp')
		const dotRightTop = lampItems.current.querySelector('#lamp_svg__dot-right-top')
		const dotRightCenter = lampItems.current.querySelector('#lamp_svg__dot-right-middle')
		const dotRightBottom = lampItems.current.querySelector('#lamp_svg__dot-right-bottom')
		const dotLeftTop = lampItems.current.querySelector('#lamp_svg__dot-left-top')
		const dotLeftCenter = lampItems.current.querySelector('#lamp_svg__dot-left-middle')
		const dotLeftBottom = lampItems.current.querySelector('#lamp_svg__dot-left-bottom')

		// arms
		const timeline = anime.timeline({
			autoplay: play,
			loop: true
		});

		timeline
		.add({
			targets: [heartTop, heartLeft, heartRight],
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			duration: 1000,
			delay: anime.stagger(100, {start: 500})
		}, 400)
		.add({
			targets: [heartTop, heartLeft, heartRight],
			easing: 'easeInOutSine',
			keyframes: [
				{opacity: 0, duration: 200},
				{opacity: 1, duration: 200},
				{opacity: 0, duration: 200},
				{opacity: 1, duration: 200, endDelay: 1000},
				{opacity: 0, duration: 200, endDelay: 1400}
			]
		}, '-=100')
		.add({
			targets: lamp,
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			duration: 600
		}, 800)
		.add({
			targets: [dotLeftBottom, dotRightBottom, dotLeftCenter, dotRightCenter, dotLeftTop, dotRightTop],
			easing: 'easeInOutElastic(1, .6)',
			opacity: 1,
			duration: 1000,
			delay: anime.stagger(100, {start: 500})
		}, 600)
		.add({
			targets: [dotLeftBottom, dotRightBottom, dotLeftCenter, dotRightCenter, dotLeftTop, dotRightTop],
			easing: 'easeInOutElastic(1, .6)',
			opacity: 0,
			duration: 1000,
			delay: anime.stagger(100, {start: 500})
		}, '-=2000')
		.add({
			targets: lamp,
			easing: 'easeInOutElastic(1, .6)',
			opacity: 0,
			duration: 1000
		}, '-=1000')
		.add({
			targets: handTop.current,
			keyframes:[
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0.3%', translateX: '0.3%', rotate: 1, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0%', translateX: '0%', rotate: 2, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0.2%', translateX: '0.2%', rotate: -1, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0.1%', translateX: '0.2%', rotate: 1, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0.2%', translateX: '0%', rotate: 2, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0%', translateX: '0.2%', rotate: -1, duration: 700, easing: 'easeInOutSine'},
				{translateY: '0%', translateX: '0%', rotate: 0, duration: 700, easing: 'easeInOutSine'}
			]
		}, 200)
		.add({
			targets: handLeft.current,
			keyframes:[
				{translateY: '-53%', translateX: '106%', rotate: 1, duration: 900, easing: 'easeInOutSine'},
				{translateY: '-51%', translateX: '107%', rotate: 3, duration: 700, easing: 'easeInOutSine'},
				{translateY: '-55%', translateX: '109%', rotate: 2, duration: 700, easing: 'easeInOutSine'},
				{translateY: '-52%', translateX: '106%', rotate: 1, duration: 700, easing: 'easeInOutSine'},
				{translateY: 0, translateX: 0, rotate: 2, duration: 900, easing: 'easeInOutSine', endDelay: 1000}
			]
		}, 200)
		.add({
			targets: handRight.current,
			keyframes:[
				{translateY: '-52%', translateX: '-95%', rotate: 2, duration: 850, easing: 'easeInOutSine'},
				{translateY: '-55%', translateX: '-101%', rotate: -1, duration: 750, easing: 'easeInOutSine'},
				{translateY: '-48%', translateX: '-95%', rotate: 3, duration: 700, easing: 'easeInOutSine'},
				{translateY: '-50%', translateX: '-97%', rotate: 1, duration: 750, easing: 'easeInOutSine'},
				{translateY: 0, translateX: 0, rotate: -1, duration: 850, easing: 'easeInOutSine', endDelay: 1000}
			]
		}, 300)

	}, [play])
	return (
		<>
			<Hearts ref={hearts}/>
			<Lamp ref={lampItems}/>
			<HandRight src={handRightSrc} ref={handRight}/>
			<HandLeft src={handLeftSrc} ref={handLeft}/>
			<HandTop src={handTopSrc} ref={handTop}/>
			<Eyes src={eyesSrc} ref={eyes}/>
			<Smiley src={smileySrc} ref={smiley}/>
		</>
	)
};

export default KopfstandStarten;